import type { ConnectorDefinition } from "./types";

export function getAuthorizationItem(definition?: ConnectorDefinition) {
  return definition?.steps
    .flatMap((step) => step.items)
    .find((item) => item.kind === "authorization");
}
